import type { MapLayerState, MapLayerActions } from "@/types/stores/map";

export function createNativeLayerActions(
  set: any,
  get: () => MapLayerState & MapLayerActions
) {
  return {
    setTextLayersVisible: (visible: boolean) => {
      set(
        (_state: MapLayerState) => ({
          textLayersVisible: visible,
        }),
        false,
        "map/setTextLayersVisible"
      );
    },

    setRoadsLayersVisible: (visible: boolean) => {
      set(
        (_state: MapLayerState) => ({
          roadsLayersVisible: visible,
        }),
        false,
        "map/setRoadsLayersVisible"
      );
    },

    toggleTextLayers: () => {
      const newValue = !get().textLayersVisible;
      get().setTextLayersVisible(newValue);
    },

    toggleRoadsLayers: () => {
      const newValue = !get().roadsLayersVisible;
      get().setRoadsLayersVisible(newValue);
    },

    setDataLabelsVisible: (visible: boolean) => {
      set(
        (_state: MapLayerState) => ({
          dataLabelsVisible: visible,
        }),
        false,
        "map/setDataLabelsVisible"
      );
    },

    toggleDataLabels: () => {
      const state = get();
      const newValue = !state.dataLabelsVisible;
      get().setDataLabelsVisible(newValue);
    },
  };
}

